import React, { useEffect, useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Calculatrice du risque de diabète";
const DESCRIPTION =
  "Calculatrice du risque de diabète en francais pour estimer vos indicateurs de sante rapidement. Entrez vos donnees et obtenez un resultat clair avec des reperes utiles pour le suivi quotidien.";
const KEYWORDS =
  "du risque de diabète, calculatrice du risque de diabète, calcul en ligne, sante, bien-etre, indicateurs sante, resultat rapide";
const OG_URL =
  "https://do-calculate.com/calculator/fr/diabetes-risk-calculator/";
function DiabetesRiskCalculator() {
  const [age, setAge] = useState(0);
  const [sex, setSex] = useState(1);
  const [ethnicity, setEthnicity] = useState(1);
  const [physicalActivity, setPhysicalActivity] = useState(1);
  const [height, setHeight] = useState(0);
  const [weight, setWeight] = useState(0);
  const [bmi, setBMI] = useState(0);
  const [familyHistory, setFamilyHistory] = useState(1);
  const [highBloodPressure, setHighBloodPressure] = useState(0);
  const [result, setResult] = useState("");
  const [error, setError] = useState("");
  useEffect(() => {
    if (height > 0 && weight > 0) {
      const heightInMeters = height / 100;
      const calculatedBMI = weight / (heightInMeters * heightInMeters);
      setBMI(calculatedBMI.toFixed(1));
    }
  }, [height, weight]);
  const calculateRiskScore = () => {
    let score = 0;
    score += parseInt(familyHistory, 10);
    score += parseInt(highBloodPressure, 10);
    const ageNum = parseInt(age, 10);
    if (ageNum >= 60) {
      score += 3;
    } else if (ageNum >= 50) {
      score += 2;
    } else if (ageNum >= 40) {
      score += 1;
    }
    if (parseInt(ethnicity, 10) === 1) {
      score += 1;
    }
    if (parseInt(physicalActivity, 10) === 0) {
      score += 1;
    }
    score += parseInt(sex, 10);
    const bmiNum = parseFloat(bmi);
    if (bmiNum >= 40) {
      score += 3;
    } else if (bmiNum >= 30) {
      score += 2;
    } else if (bmiNum >= 25) {
      score += 1;
    }
    return score;
  };
  const handleCalculate = () => {
    try {
      const score = calculateRiskScore();
      const riskMessage =
        score >= 5
          ? `Score: ${score} - Vous êtes à risque élevé de prédiabète.`
          : `Score: ${score} - Vous êtes à risque faible de prédiabète.`;
      setResult(`${riskMessage} En fonction des facteurs que vous avez fournis.
        Si le score est inférieur à 5, vous êtes à risque faible! `);
    } catch (error) {
      setError(error.message);
    }
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Calculez votre risque de diabète dans 7,5 ans avec précision en utilisant notre

                  calculatrice complète! Avec cet outil avancé, vous pouvez évaluer votre probabilité
                  de développer un diabète à court terme en entrant des informations de santé essentielles
                  telles que l'âge, le sexe, la taille, l'origine ethnique, l'historique familial, le
                  niveau d'activité physique, la pression artérielle et l'indice de masse corporelle
                  (IMC).
                </p>
                <p>
                  Pourquoi devriez-vous utiliser une calculatrice de risque de diabète? Connaître votre
                  risque de diabète peut vous aider à prendre des mesures pour maintenir votre santé et
                  prévenir cette maladie chronique. En comprenant votre probabilité de développer un
                  diabète, vous pouvez apporter des changements sains à votre mode de vie, comme suivre
                  un régime équilibré, faire de l'exercice régulièrement et contrôler votre poids, pour
                  réduire votre risque de diabète.
                </p>
                <p>
                  Les points pour chaque facteur de risque ci-dessous sont additionnés pour calculer le
                  score final. Par exemple, si vous répondez "oui" à la question "Avez-vous un parent
                  atteint de diabète?", vous obtenez un point sous "Historique familial". Si vous
                  répondez "non" à "Avez-vous une tension artérielle élevée?", vous obtenez 0 point
                  sous "Tension artérielle élevée", et ainsi de suite pour tous les facteurs de risque.
                  Un score total de 5 points ou plus indique un risque élevé de prédiabète.
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div>
                  <div>
                    <hr />
                    <div className="form-group">
                      <label className="form-label ms-2">Âge</label>
                      <input
                        type="number"
                        value={age}
                        onChange={(e) => setAge(e.target.value)}
                        placeholder="Entrez votre âge"
                        className="form-control"
                        style={{ width: "78%" }}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="sex">Sexe</label>
                      <select
                        id="sex"
                        value={sex}
                        onChange={(e) => setSex(e.target.value)}
                        className="form-control"
                        style={{ width: "78%" }}
                      >
                        <option value={1}>Homme</option>
                        <option value={0}>Femme</option>
                      </select>
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="ethnicity">Origine ethnique</label>
                      <select
                        id="ethnicity"
                        value={ethnicity}
                        onChange={(e) => setEthnicity(e.target.value)}
                        className="form-control"
                        style={{ width: "78%" }}
                      >
                        <option value={1}>
                          Latino-américain, africain ou asiatique
                        </option>
                        <option value={0}>Blanc non-hispanophone</option>
                      </select>
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="physicalActivity">
                        Niveau d'activité physique
                      </label>
                      <select
                        id="physicalActivity"
                        value={physicalActivity}
                        onChange={(e) => setPhysicalActivity(e.target.value)}
                        className="form-control"
                        style={{ width: "78%" }}
                      >
                        <option value={1}>Actif</option>
                        <option value={0}>Inactif</option>
                      </select>
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="height">Taille (cm)</label>
                      <input
                        id="height"
                        type="number"
                        value={height}
                        onChange={(e) => setHeight(e.target.value)}
                        placeholder="Entrez votre taille"
                        className="form-control"
                        style={{ width: "78%" }}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="weight">Poids (kg)</label>
                      <input
                        id="weight"
                        type="number"
                        value={weight}
                        onChange={(e) => setWeight(e.target.value)}
                        placeholder="Entrez votre poids"
                        className="form-control"
                        style={{ width: "78%" }}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="bloodPressure">
                        Avez-vous une tension artérielle élevée?
                      </label>
                      <select
                        id="bloodPressure"
                        value={highBloodPressure}
                        onChange={(e) => setHighBloodPressure(e.target.value)}
                        className="form-control"
                        style={{ width: "78%" }}
                      >
                        <option value={0}>Non</option>
                        <option value={1}>Oui</option>
                      </select>
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="familyHistory">
                        Avez-vous des antécédents familiaux de diabète?
                      </label>
                      <select
                        id="familyHistory"
                        value={familyHistory}
                        onChange={(e) => setFamilyHistory(e.target.value)}
                        className="form-control"
                        style={{ width: "78%" }}
                      >
                        <option value={0}>Non</option>
                        <option value={1}>Oui</option>
                      </select>
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      Calculer le risque
                    </button>
                  </div>
                  <br />
                  {error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      Erreur: {error}
                    </p>
                  )}
                  {result && (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>Résultat:</h4>
                      <p>{result}</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
  <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Conseils d'utilisation</h3></div>
              <div className="info-section-body">
                <p>Pour obtenir un resultat pertinent, verifiez vos unites, saisissez des valeurs realistes et utilisez ce calcul comme aide a la decision, puis adaptez selon votre situation.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Facteurs de risque du diabte</h3></div>
              <div className="info-section-body"><p>Pour obtenir un resultat pertinent, verifiez vos unites, saisissez des valeurs realistes et utilisez ce calcul comme aide a la decision, puis adaptez selon votre situation.</p></div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Prvention</h3></div>
              <div className="info-section-body"><p>Pour obtenir un resultat pertinent, verifiez vos unites, saisissez des valeurs realistes et utilisez ce calcul comme aide a la decision, puis adaptez selon votre situation.</p></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DiabetesRiskCalculator;
